import { Body, Button, Column, Radio, RadioGroup } from "@gadgetinc/widgets";
import { AuthMarketingTheme } from "@gadgetinc/widgets/src/AuthTheme";
import { GadgetLogoType } from "@gadgetinc/widgets/src/icons/GadgetLogo";
import { ThemeProvider, useStyletron } from "baseui";
import { observer } from "mobx-react-lite";
import React from "react";
import { technicalLevels } from "state-trees/src/tags";
import type { SurveyStep } from "../../../client-state-trees/auth/Survey";

const technicalLevelValueToLabel = (value: (typeof technicalLevels)[number]) => {
  switch (value) {
    case "full_stack_dev":
      return "An experienced full-stack developer";
    case "frontend_dev":
      return "A frontend developer";
    case "junior_dev":
      return "A junior developer";
    case "citizen_dev":
      return "A non-technical, citizen developer";
  }
};

const Inner = observer((props: { step: SurveyStep }) => {
  const [css, $theme] = useStyletron();

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "white",
      }}
    >
      <div
        className={css({
          position: "absolute",
          top: $theme.sizing.scale600,
          left: $theme.sizing.scale600,
        })}
      >
        <GadgetLogoType draggable={false} className={css({ height: "30px" })} />
      </div>
      <Column
        $style={{
          width: "100%",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Column $gap={$theme.sizing.scale900}>
          <Body
            $style={{
              fontSize: $theme.sizing.scale700,
              fontWeight: 700,
            }}
          >
            How technical are you?
          </Body>
          <Column $gap={$theme.sizing.scale800}>
            <Column $gap={$theme.sizing.scale600}>
              <RadioGroup
                value={props.step.answers.get("technicalLevel")}
                onChange={(event) => {
                  props.step.setAnswer("technicalLevel", event.target.value);
                }}
              >
                {technicalLevels.map((level) => (
                  <Radio
                    key={level}
                    value={level}
                    overrides={{
                      Root: {
                        style: {
                          ":not(:last-child)": {
                            marginBottom: $theme.sizing.scale600,
                          },
                        },
                      },
                    }}
                  >
                    <Body
                      $style={{
                        fontSize: $theme.sizing.scale600,
                      }}
                    >
                      {technicalLevelValueToLabel(level)}
                    </Body>
                  </Radio>
                ))}
              </RadioGroup>
            </Column>
            <div>
              <Button
                onClick={() => {
                  props.step.submit();
                }}
                disabled={!props.step.answers.get("technicalLevel")}
              >
                Confirm
              </Button>
            </div>
          </Column>
        </Column>
      </Column>
    </div>
  );
});

export const TechnicalSurvey = observer((props: { step: SurveyStep }) => {
  return (
    <ThemeProvider theme={AuthMarketingTheme}>
      <Inner step={props.step} />
    </ThemeProvider>
  );
});
